import React, { Component } from "react";
import FilterCategories from "./components/FilterCategories";
import Filters from "./components/Filters";
import Products from "./components/Products";
import Message from "./components/Message";
import ReactPaginate from "react-paginate";
import update from "immutability-helper";
const elementary = require("../../vendor/elementary.js");

const perPage = 24;

class ProductSelector extends Component {
  constructor(props) {
    super(props);

    var products         = this.props.products;
    var filters          = this.props.filters;
    var filteredProducts = products;
    var filteredFilters  = filters;

    // If this selector has categories, hide products until category chosen
    if (this.props.categories) {
      filteredProducts = [];
      filteredFilters = [];
    }

    this.state = {
      categories: this.props.categories ? this.props.categories : null,
      filters: filters,
      filteredFilters: filteredFilters,
      products: products,
      filteredProducts: filteredProducts,
      pageCount: Math.ceil(filteredProducts.length / perPage),
      currPage: 1,
      mod: this.props.mod
    };

    this.handleCategoryChange = this.handleCategoryChange.bind(this);
    this.handleFilterChange   = this.handleFilterChange.bind(this);
    this.filterFilters        = this.filterFilters.bind(this);
    this.filterProducts       = this.filterProducts.bind(this);
    this.handleResetFilters   = this.handleResetFilters.bind(this);
    this.handlePageClick      = this.handlePageClick.bind(this);
  }

  filterFilters() {
    console.log("Filtering filters");

    var filtered = this.state.filters.filter(
      filter => filter["categoryId"] === this.state.categories.selected
    );

    this.setState({
      filteredFilters: filtered
    });
  }

  filterProducts() {
    console.log("Filtering products");

    var filtered = this.state.products;

    // If selector has categories, filter products by category
    if (this.state.categories !== null) {
      filtered = filtered.filter(
        product =>
          product.attributes["categoryId"] === this.state.categories.selected
      );
    }

    var filter = null;

    // Filter products by chosen filters
    for (var i = 0; i < this.state.filteredFilters.length; i++) {
      filter = this.state.filteredFilters[i];

      if (filter.selected !== "") {
        if (filter.key == "buildUp") {
          filtered = filtered.filter(
            product =>
              filter.selected >= product.attributes.buildUpMin &&
              filter.selected <= product.attributes.buildUpMax
          );
        } else if (filter.key == "application") {
          filtered = filtered.filter(
            product =>
              product.attributes.applications.indexOf(filter.selected) !== -1
          );
      } else if (filter.key == "productType") {
          filtered = filtered.filter(
            product =>
              product.attributes.types.indexOf(filter.selected) !== -1
          );
        } else if (filter.key == "driveType") {
          filtered = filtered.filter(
            product =>
              product.attributes.driveTypes.indexOf(filter.selected) !== -1
          );
        } else if (filter.key == "material") {
          // Checks whether product substrates match any of the range selected
          filtered = filtered.filter(product =>
            product.attributes.materials.some(r =>
              this.props.matchedMaterials.includes(r)
            )
          );
        } else if (filter.key == "substrate") {
          // Checks whether product substrates match any of the range selected
          filtered = filtered.filter(product =>
            product.attributes.substrates.some(r =>
              this.props.matchedSubstrates.includes(r)
            )
          );
        } else if (filter.key == "productCode") {

            if (this.props.productTypes) {

                filtered = filtered.filter(product =>
                  product.attributes.productCodes.some(r =>
                    r.toLowerCase().indexOf(filter.selected.toLowerCase()) !== -1
                  )
                );

            }
            else {
                filtered = filtered.filter(
                  product =>
                    product.code
                      .toLowerCase()
                      .indexOf(filter.selected.toLowerCase()) !== -1
                );
            }

        } else {
          filtered = filtered.filter(
            product => product.attributes[filter.key] === filter.selected
          );
        }
      }
    }

    this.setState({
      currPage: 1,
      filteredProducts: filtered,
      pageCount: Math.ceil(filtered.length / perPage)
    });
  }

  componentDidUpdate(prevProps, prevState) {
    console.log("Product Selector updated!");

    if (this.state.categories !== prevState.categories) {
      this.filterFilters();
    }

    if (this.props.filters !== prevProps.filters) {
      console.log("Filters loaded!");

      this.setState({
        filters: this.props.filters,
        filteredFilters: this.props.filters
      });
    }

    if (this.state.filteredFilters !== prevState.filteredFilters) {
      this.filterProducts();
    }

    if (this.props.products !== prevProps.products) {
      console.log("Products loaded!");
      this.setState({
        products: this.props.products,
        filteredProducts: this.props.products,
        pageCount: Math.ceil(this.props.products.length / perPage)
      });
    }

    elementary();
  }

  handleCategoryChange(id) {
    console.log("Category changed");

    var amendedCategories = update(this.state.categories, {
      selected: { $set: id }
    });

    this.setState({
      categories: amendedCategories
    });
  }

  handleFilterChange(fld) {
    console.log("Filter changed");
    console.log(fld);

    var val = fld.value;
    if (fld.type !== "text" && fld.value !== "") {
      val = parseFloat(fld.value);
    }

    // var val         = (fld.value === '') ? '' : parseFloat(fld.value);
    var key = fld.id;
    var filterIndex = null;
    var filter = this.state.filteredFilters.find((obj, index) => {
      if (obj.key == key) {
        filterIndex = index;
        return obj;
      }
    });

    var amendedFilters = update(this.state.filteredFilters, {
      [filterIndex]: {
        selected: { $set: val }
      }
    });

    this.setState({
      filteredFilters: amendedFilters
    });

    if (filter.key == "material") {
      this.props.onMaterialFilterChange(val);
    }
    if (filter.key == "substrate") {
      this.props.onSubstrateFilterChange(val);
    }
  }

  handleResetFilters() {
    console.log("resetting filters");

    var filters = this.state.filteredFilters;
    var amendedFilters = [];

    for (var i = 0; i < filters.length; i++) {
      var filter = filters[i];
      filter.selected = "";
      amendedFilters[i] = filter;
    }

    this.setState({
      currPage: 1,
      filteredFilters: amendedFilters
    });
  }

  handlePageClick(data) {
    var newPage = data.selected + 1;
    this.setState({ currPage: newPage });
  }

  render() {
    var items = <Message />;
    var categories = "";

    if (this.state.filteredProducts.length > 0) {
      items = (
        <Products
          products={this.state.filteredProducts}
          page={this.state.currPage}
          perPage={perPage}
          mod={this.state.mod}
          categories={this.state.categories}
        />
      );
    }

    if (this.state.categories !== null) {
      categories = (
        <FilterCategories
          label={this.state.categories.title}
          items={this.state.categories.options}
          selected={this.state.categories.selected}
          onCategoryChange={this.handleCategoryChange}
        />
      );
    }

    return (
      <div>
        <div className="strip">
          <div className="wrapper">
            <div className="product-selector">
              <h2 className="product-selector__title">{this.props.title}</h2>

              {categories}

              <div className="product-selector__filters">
                <Filters
                  items={this.state.filteredFilters}
                  categories={this.state.categories}
                  onFilterChange={this.handleFilterChange}
                  onResetFilters={this.handleResetFilters}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="strip strip--alt">
          <div className="wrapper">
            <div
              className="results"
              itemScope
              itemType="http://schema.org/ItemList"
            >
              <div className="results__count">
                <strong itemProp="numberOfItems">
                  {this.state.filteredProducts.length}
                </strong>{" "}
                results found
              </div>

              <div className="results__items">{items}</div>

              <div className="results__pagination">
                <nav className="pagination elementary">
                  <ReactPaginate
                    previousLabel={"previous"}
                    nextLabel={"next"}
                    breakLabel={<span className="pagination__link">...</span>}
                    breakClassName={"pagination__items--break"}
                    pageCount={this.state.pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={this.handlePageClick}
                    containerClassName={"pagination__items"}
                    pageClassName={"pagination__item"}
                    pageLinkClassName={"pagination__link"}
                    activeClassName={"pagination__item--active"}
                    previousClassName={"pagination__item"}
                    previousLinkClassName={"pagination__link"}
                    previousLabel={"<"}
                    nextClassName={"pagination__item"}
                    nextLinkClassName={"pagination__link"}
                    nextLabel={">"}
                    disabledClassName={"pagination__item--disabled"}
                    forcePage={this.state.currPage - 1}
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ProductSelector;
